import React, { useState, useEffect } from 'react';
import { selectorBeneficiosVaVr } from '@core/slice/beneficiosVaVr.slice';
import { useAppSelector } from '@store/hooks';
import { Box, Button, Card, CardActions, CardContent, Container, Typography } from '@mui/material';
import { colaboradorService } from '@core/services';
import { LoadingView } from '@core/components';
import { AlertComponent } from '@core/components/atoms/alert-component';

import { ReactComponent as AleloAlimentacao } from '@assets/alelo-alimentacao.svg';
import { ReactComponent as AleloRefeicao } from '@assets/alelo-refeicao.svg';
import { selectorAuth } from '@core/slice/login.slice';

interface IBeneficiosVaVr {}
export const AlimentacaoRefeicao: React.FC<IBeneficiosVaVr> = () => {
    const { data, loading, error } = useAppSelector(selectorBeneficiosVaVr);
    const [cardType, setCardType] = useState<string | null>(null);

    const {
        auth: { user }
    } = useAppSelector(selectorAuth);

    useEffect(() => {
        colaboradorService.beneficiosVaVr();
    }, []);

    useEffect(() => {
        if (data && data.message && !loading) {
            if (data.message.includes('Alimentação')) {
                setCardType('Alimentação');
            } else {
                setCardType('Refeição');
            }
        }
    }, [data, loading]);

    const cardImageStyle = {
        width: '100%',
        height: 'auto'
    };
    const cardUserNameStyle = {
        position: 'absolute',
        bottom: '17%',
        left: '10.5%',
        lineHeight: 1,
        fontWeight: 600,
        fontSize: '.55rem',
        color: cardType === 'Alimentação' ? '#fff' : '#000',
        opacity: '.7'
    };

    const handleConsultarSaldo = () => {
        window.open('https://www.meualelo.com.br/', '_blank');
    };

    return (
        <Container maxWidth="xl" sx={{ px: '2rem' }}>
            {loading && <LoadingView />}

            {error && !loading ? (
                <AlertComponent type="error" detailed={true} message={error ?? '-'} />
            ) : !loading ? (
                <>
                    <Card sx={{ maxWidth: 360 }}>
                        <Box sx={{ position: 'relative' }}>
                            {cardType === 'Alimentação' ? <AleloAlimentacao style={cardImageStyle} /> : <AleloRefeicao style={cardImageStyle} />}
                            <Typography sx={cardUserNameStyle}>{user?.nome}</Typography>
                        </Box>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                                Vale {cardType}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {data.message}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" onClick={handleConsultarSaldo}>
                                Consulte seu saldo
                            </Button>
                        </CardActions>
                    </Card>
                </>
            ) : (
                ''
            )}
        </Container>
    );
};
